export default __webpack_public_path__ + "static/media/47_3_1.1ee981fd.png";